import { DeleteOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import SortIcon from "../../../global/components/SortIcon";

export const PlatesColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setParams,
  params,
  hideColmn,
) => {
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {};

  return [
    {
      title: "Name",
      dataIndex: "PlateName",
      key: "PlateName",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="PlateName"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "PlateName",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Description",
      dataIndex: "PlateDesc",
      key: "PlateDesc",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="PlateDesc"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "PlateDesc",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Code",
      dataIndex: "AccessCode",
      key: "AccessCode",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="AccessCode"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "AccessCode",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "OEM",
      dataIndex: "OemName",
      key: "OemName",
      hidden: hideColmn,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="OemNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "OemNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Dealer",
      dataIndex: "DealerName",
      key: "DealerName",
      hidden: hideColmn,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="DealerNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "DealerNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      render: (text, record, rowIndex) =>
        hoveredRow === rowIndex ? (
          <div className="absolute top-2 right-5">
            <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
              <Tooltip title="Edit">
                <div className="hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] mr-1 ">
                  <Link
                    to={`/plate/edit/${record?.PlateNo}`}
                    onClick={(e) => e.stopPropagation()}
                    className=" hover:text-[#636262ee]"
                  >
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="!text-[#50565e]"
                    />
                  </Link>
                </div>
              </Tooltip>
              <Tooltip title="Delete">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                    setSelectedRowKeys([record?.PlateNo]);
                  }}
                  className="cursor-pointer hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] "
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        ) : null,
    },
  ];
};
